<template>
  <div class="modal-card card">
    <header class="card-header">
      <div class="card-header-title is-centered columns is-mobile">
        <div
          class="column has-text-centered"
          :class="newUser === true ? 'tab-is-selected': ''"
          @click="toggleSignUpOrLogIn('new')"
        >
          New Users
        </div>
        <div
          class="column has-text-centered"
          :class="newUser === false ? 'tab-is-selected': ''"
          @click="toggleSignUpOrLogIn('existing')"
        >
          Existing Users
        </div>
      </div>
    </header>
    <section
      v-if="newUser"
      class="modal-card-body"
    >
      <h5 class="title is-5 has-text-centered">
        No names. Just skills.
      </h5>
      <p
        id="value-proposition"
        class="has-text-centered"
      >
        Let your talent reach hundreds of top companies without
        exposing your identity.
      </p>
      <form @submit.prevent="validateBeforeSubmit()">
        <div class="field">
          <label class="label">Username</label>
          <!--<p class="help label-help has-text-grey">A unique name that preserves your anonymity.</p>-->
          <div class="control">
            <input
              v-model="candidateUserName"
              v-validate="'required'"
              class="input"
              name="username"
              type="text"
              placeholder="Not your actual name!"
            >
            <p class="help is-danger">
              {{ errors.first('username') }}
            </p>
          </div>
        </div>
        <div class="field">
          <label class="label no-margin-bottom">Email</label>
          <small class="is-size-7 has-text-grey">We will never reveal your email to anybody</small>
          <div class="control">
            <input
              v-model="candidateEmail"
              v-validate="'required'"
              class="input"
              type="email"
              name="email"
              placeholder="myname@company.com"
            >
            <p class="help is-danger">
              {{ errors.first('email') }}
            </p>
          </div>
        </div>
        <div class="field">
          <label class="label">Password</label>
          <div class="control has-icons-right">
            <input
              v-model="candidatePassword"
              v-validate="'required'"
              class="input"
              :type="!passwordIsShowing ? 'password' : 'text'"
              name="password"
              placeholder="DontForgetMe"
            >
            <span
              id="show-password"
              class="icon is-small is-right"
              :class="passwordIsShowing ? 'has-text-primary' : ''"
              @click="toggleShowPassword()"
            >
              <i class="fas fa-eye" />
            </span>
            <p class="help is-danger">
              {{ errors.first('password') }}
            </p>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input
              id="terms-candidate"
              v-model="termsAccepted"
              v-validate="'required'"
              class="is-checkradio"
              type="checkbox"
              name="terms-candidate"
            >
            <label for="terms-candidate">
              <small class="is-size-7">
                I agree to the
                <a
                  href="https://app.termly.io/document/terms-of-use-for-website/4d33d7ab-ebae-4415-8261-c163a914d3de"
                  target="_blank"
                  class="has-text-primary"
                >Terms of Use</a>
                and
                <a
                  href="https://app.termly.io/document/privacy-policy/2a7b68d5-3ce9-47d4-ae3b-ac58b7c0f1b2"
                  target="_blank"
                  class="has-text-primary"
                >Privacy Policy</a>
              </small>
            </label>
            <span
              v-show="errors.has('terms-candidate')"
              class="help is-danger"
            >{{ errors.first('terms-candidate') }}</span>
          </div>
        </div>
        <div class="control has-text-centered">
          <button
            type="submit"
            class="button is-rounded is-primary has-text-weight-bold is-fullwidth sign-up-button"
            :class="isLoading ? 'is-loading' : ''"
          >
            Sign Up
          </button>
        </div>
      </form>
    </section>
    <section
      v-else
      class="modal-card-body"
    >
      <log-in-form
        v-if="!isForgotPasswordFormVisible"
        @togglePasswordResetForm="handleTogglePasswordResetForm"
      />
      <reset-password-form v-else @toggleLoginForm="toggleLoginForm($event)" />
    </section>
  </div>
</template>

<script>
import LogInForm from '@/components/Login/LogInForm';
import ResetPasswordForm from '@/components/Login/ResetPasswordForm';

export default {
  name: 'SignUpCandidateFormCard',
  components: {
    LogInForm,
    ResetPasswordForm
  },
  data () {
    return {
      candidateUserName: '',
      candidatePassword: '',
      candidateEmail: '',
      termsAccepted: false,
      isLoading: false,
      newUser: true,
      passwordIsShowing: false,
      isForgotPasswordFormVisible: false
    };
  },
  computed: {
    isFormValid () {
      return Object.keys(this.fields).every(key => this.fields[key].valid);
    }
  },
  methods: {
    toggleSignUpOrLogIn (userType) {
      if (userType === 'new') {
        this.newUser = true;
      } else if ((userType === 'existing')) {
        this.newUser = false;
      }
    },
    sendCandidateSignUp () {
      this.isLoading = true;
      this.$store
        .dispatch('signUpNewUser', {
          username: this.candidateUserName,
          email: this.candidateEmail.toLowerCase(),
          password: this.candidatePassword,
          agreed: this.termsAccepted,
          user_type: 'candidate'
        })
        .then(response => {
          this.isLoading = false;
          this.$router.push({ path: '/account/welcome' });
        })
        .catch(error => {
          this.isLoading = false;
          if (error.data && error.data.details.includes('username_cand')) {
            this.$toasted.show('Username already exists');
          } else if (error.data && error.data.details.includes('username')) {
            this.$toasted.show('Email already exists.');
          } else {
            this.$toasted.show('Oops, something went wrong, please try again.');
          }
          console.log(error);
        });
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendCandidateSignUp();
          return;
        }
        console.log('Correct them errors!');
      });
    },
    toggleShowPassword () {
      this.passwordIsShowing = !this.passwordIsShowing;
    },
    handleTogglePasswordResetForm () {
      this.isForgotPasswordFormVisible = true;
    },
    toggleLoginForm ($event) {
      this.isForgotPasswordFormVisible = !$event;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-card {
  margin: 0 0.5rem;
}

.icon {
  pointer-events: initial !important;
}

#show-password {
  cursor: pointer;
}

#show-password:hover {
  color: $primary;
}

.sign-up-button {
  margin-top: 1rem;
}

.modal-card-body {
  padding: 1.5rem 3rem;
  border-radius: 0 0 $radius-xl $radius-xl;
}

#value-proposition {
  margin-bottom: 1rem;
}

.button.is-large {
  margin-top: 2rem;
}

.card-header-title {
  padding: 0.75rem;
}

.card-header-title > .column {
  background-color: $white-ter;
  border: solid $white-ter;
  border-width: 0 0 2px 0;
  color: $grey;
}

.card-header-title > .column:hover {
  cursor: pointer;
  border: solid $primary;
  border-width: 0 0 2px 0;
  color: $dark;
}

.card-header-title .tab-is-selected {
  z-index: 1;
  background-color: white;
  border: solid $primary;
  border-width: 0 0 2px 0;
  color: $primary;
  box-shadow: 1px 0 20px 0 $grey-lighter;
}

label[for="terms-candidate"] {
  small {
    vertical-align: text-top;
  }

  margin-left: 0 !important;
}

@media screen and (min-width: 640px) {
  .modal-card {
    max-width: 450px;
  }
}

.label-help {
  margin-top: -0.6rem;
  margin-bottom: 0.5rem;
}

/* always present */
.expand-transition {
  transition: all 0.3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}

/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
</style>
